class ComponentCountdown extends Theme.Component {
  connectedCallback() {
    this.getEndTime();
    this.update();

    this.elements.timer.style.opacity = 1;

    setInterval(() => {
      this.update();
    }, 1000);
  }

  getEndTime() {
    const end_string = this.dataset.end;
    const [date_part, time_part] = end_string.split(" ");
    const [year, month, day] = date_part.split("-").map(Number);
    const [hours, minutes] = time_part.split(":").map(Number);

    this.end_time = new Date(year, month - 1, day, hours, minutes).getTime();
  }

  update() {
    const remaining_milliseconds = this.end_time - Date.now();

    if (remaining_milliseconds <= 0) {
      this.style.display = "none";
      return;
    }

    const total_seconds = Math.floor(remaining_milliseconds / 1000);

    const hours = Math.floor(total_seconds / 3600);
    const minutes = Math.floor((total_seconds % 3600) / 60);
    const seconds = total_seconds % 60;

    this.elements.timer.textContent =
    this.formatUnit(hours) + " Hrs : " +
    this.formatUnit(minutes) + " Min : " +
    this.formatUnit(seconds) + " Sec";
  }

  formatUnit(value) {
    return value < 10 ? "0" + value : String(value);
  }
}

customElements.define("component-countdown", ComponentCountdown);
